import { Html } from '@react-three/drei'
import { useState, useEffect } from 'react'
export default function Fallback(){
    const [tick, setTick] = useState(0)
    const [dots, setDots] = useState('')

    useEffect(() => {
        const interval = setInterval(() => {
            setTick(tick + 1)
            setDots([...Array((tick) % 4)].reduce((acc) => {
                acc = `${acc}.`
                console.log(acc)
                return acc
            }, ''))
        }, 600);

        return () => clearInterval(interval);
      }, [tick]);

    return <Html
        transform
        wrapperClass="fullscreenHTML"
        distanceFactor={ 1.17 }
        rotation={[0, -3.14, 0]}
        >
        <div>Loading{dots}</div>
    </Html>
}
